import React, { useState } from 'react';
import { motion } from 'framer-motion';
import bgHeroSection from '../../assets/images/bgherosection.png';
import CapacitaSegModal from '../Modals/CapacitaSegModal';
import ExameSegModal from '../Modals/ExameSegModal';

const HeroSection = () => {
  const [isCapacitaSegModalOpen, setIsCapacitaSegModalOpen] = useState(false);
  const [isExameSegModalOpen, setIsExameSegModalOpen] = useState(false);

  return (
    <section className="relative h-[700px] bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="absolute inset-0">
        <img 
          src={bgHeroSection} 
          alt="Background Hero Section" 
          className="w-full h-full object-cover opacity-10"
        />
      </div>
      
      <div className="container mx-auto px-4 py-16 relative z-10 h-full flex flex-col items-center justify-center">
        <div className="w-full max-w-[280px] md:max-w-none">
          <motion.img
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            src="/logos/focoseg-color.png"
            alt="FocoSeg Logo"
            className="w-full h-auto md:h-28 mb-8 object-contain"
          />
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-center max-w-4xl mx-auto"
        >
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 text-teal-900 leading-tight">
            Somos a melhor escolha para você, sua empresa e seus colaboradores.
          </h1>
          <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold mb-8 text-teal-800">
            Referência em Segurança do Trabalho e Saúde Ocupacional.
          </h2>

          <motion.a
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            href="https://wa.link/chkmgd"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-lg inline-flex items-center space-x-2 transition-colors duration-300"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
            </svg>
            Entre em contato
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2 transform transition-transform group-hover:translate-x-1" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </motion.a>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8">
          {[
            { number: '10.000+', label: 'Clientes atendidos' },
            { number: '5+', label: 'Anos de experiência' },
            { number: '98%', label: 'Satisfação dos clientes' },
            { number: '50+', label: 'Profissionais especializados' }
          ].map((stat, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.6 + (index * 0.1) }}
              className="bg-teal-50 p-4 rounded-lg text-center border border-teal-100 hover:bg-teal-100/50 transition-colors duration-300"
            >
              <h3 className="text-2xl font-bold text-teal-900 mb-1">{stat.number}</h3>
              <p className="text-teal-800 text-sm">{stat.label}</p>
            </motion.div>
          ))}
        </div>

        <div className="flex justify-center items-center gap-6 md:gap-12 mt-8 w-full max-w-[590px] md:max-w-none">
          <motion.img
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.8 }}
            src="/logos/capacitaseg-color.png"
            alt="CapacitaSeg Logo"
            className="w-1/3 md:w-auto h-auto md:h-12 object-contain cursor-pointer hover:scale-105 transition-transform"
            onClick={() => setIsCapacitaSegModalOpen(true)}
          />
          <motion.img
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 1.0 }}
            src="/logos/exameseg-color.png"
            alt="ExameSeg Logo"
            className="w-1/3 md:w-auto h-auto md:h-12 object-contain cursor-pointer hover:scale-105 transition-transform"
            onClick={() => setIsExameSegModalOpen(true)}
          />
        </div>
      </div>

      <CapacitaSegModal 
        isOpen={isCapacitaSegModalOpen}
        onClose={() => setIsCapacitaSegModalOpen(false)}
      />
      <ExameSegModal 
        isOpen={isExameSegModalOpen}
        onClose={() => setIsExameSegModalOpen(false)}
      />
    </section>
  );
};

export default HeroSection;